// BI-642 — stránka autora /autor/<slug>/: sbalené bio, „Zobrazit více“ článků
// (REST businessinfo/v1/autor-articles) a formulář „Zpráva pro autora“
// (admin-post.php?action=autor-message, plugin businessinfo-autor).

function initAutorBio(bio) {
  const content = bio.querySelector('.autor-bio__content');
  const button = bio.querySelector('.js-autor-bio-toggle');

  if (!content || !button) {
    return;
  }

  // Sbalit jen pokud text přeteče výšku sbaleného stavu.
  bio.classList.add('is-collapsible');
  if (content.scrollHeight <= content.clientHeight + 1) {
    bio.classList.remove('is-collapsible');
    return;
  }

  button.hidden = false;

  const setExpanded = (expanded) => {
    bio.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? 'Zobrazit méně' : 'Zobrazit vše';
  };

  button.addEventListener('click', () => {
    setExpanded(!bio.classList.contains('is-expanded'));
  });

  // Odkaz ve skryté části bio (Tab) nesmí zůstat schovaný pod přechodem.
  content.addEventListener('focusin', () => setExpanded(true));
}

function initAutorArticles(button) {
  const list = document.querySelector('.js-autor-articles');
  const status = document.querySelector('.js-autor-articles-status');
  const announce = (text) => {
    if (status) {
      status.textContent = text;
    }
  };

  if (!list) {
    return;
  }

  button.addEventListener('click', () => {
    if (button.classList.contains('is-loading')) {
      return;
    }

    const page = parseInt(list.dataset.page || '1', 10) + 1;
    const url = window.location.origin + '/wp-json/businessinfo/v1/autor-articles'
      + '?autor=' + encodeURIComponent(list.dataset.autor) + '&page=' + page;
    const headers = { Accept: 'application/json' };

    if (typeof window.biRestNonce !== 'undefined' && window.biRestNonce) {
      headers['X-WP-Nonce'] = window.biRestNonce;
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    announce('Načítám další články…');

    fetch(url, { headers, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .then((data) => {
        const firstNew = list.children.length;

        list.insertAdjacentHTML('beforeend', (data.postsList || []).join(''));
        list.dataset.page = String(page);
        announce('Další články jsou načtené.');

        // Klávesnice: pokračovat na první nově načtené kartě.
        const firstLink = list.children[firstNew] && list.children[firstNew].querySelector('a');
        if (firstLink) {
          firstLink.focus();
        }

        if (!data.has_more) {
          button.remove();
        }
      })
      .catch((error) => {
        console.error('Články autora se nepodařilo načíst:', error);
        announce('Další články se nepodařilo načíst, zkuste to prosím znovu.');
      })
      .finally(() => {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  });
}

function initAutorMessageForm($, form) {
  const submit = form.find('#autorMessageSubmit');

  const resetRecaptcha = () => {
    const widgetId = submit.attr('data-recaptcha-widget');
    if (typeof window.grecaptcha !== 'undefined' && widgetId !== undefined) {
      window.grecaptcha.reset(parseInt(widgetId, 10));
    }
  };

  const showBox = (selector) => {
    form.find('.modal-message-box').addClass('hidden');
    if (selector) {
      form.find(selector).removeClass('hidden');
    }
  };

  let validator = null;

  // Po úspěšném odeslání: pole bez fajfek a chyb, jako při prvním otevření.
  const resetFields = () => {
    form[0].reset();
    if (validator) {
      validator.resetForm();
    }
    form.find('input, textarea').removeClass('valid error').removeAttr('aria-invalid aria-describedby');
    form.find('.error-label').html('');
  };

  if (typeof form.validate === 'function') {
    validator = form.validate({
      focusInvalid: true,
      messages: {
        author_name: { required: 'Povinné pole' },
        author_email: { required: 'Povinné pole', email: 'Zadejte platnou e-mailovou adresu' },
        message: { required: 'Povinné pole' },
      },
      // Fajfka (.valid) jen u vyplněného pole — prázdný nepovinný Předmět zůstane neutrální.
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass(errorClass).toggleClass(validClass, $.trim($(element).val()) !== '');
      },
      // Chyba svázaná s polem (aria-describedby), aby ji čtečka přečetla při fokusu.
      errorPlacement: function (error, element) {
        const id = element.attr('id') + '-error';
        element.closest('.input-wrapper').find('.error-label').attr('id', id).html(error.text());
        element.attr({ 'aria-invalid': 'true', 'aria-describedby': id });
      },
      success: function (label, element) {
        $(element).closest('.input-wrapper').find('.error-label').html('');
        $(element).removeAttr('aria-invalid aria-describedby');
      },
    });
  }

  form.on('submit', function (e) {
    e.preventDefault();

    // Hláška z minulého odeslání nesmí zůstat vedle nových chyb polí.
    showBox(null);

    if (typeof form.valid === 'function' && !form.valid()) {
      resetRecaptcha();
      return;
    }

    submit.addClass('is-loading').attr('aria-busy', 'true');

    $.ajax({
      url: form.attr('action'),
      type: 'post',
      dataType: 'json',
      data: form.serialize(),
    })
      .done(function (data) {
        const status = data && data.status;

        if (status === 'ok') {
          resetFields();
          showBox('.js-autor-message-ok');
          form.closest('.modal').find('.js-modal-close').first().trigger('focus');
        } else if (status === 'recaptcha-fail') {
          showBox('.js-autor-message-recaptcha-fail');
        } else if (status === 'rate-limit') {
          showBox('.js-autor-message-rate-limit');
        } else {
          showBox('.js-autor-message-error');
        }
      })
      .fail(function (xhr, status, error) {
        showBox('.js-autor-message-error');
        console.error('Zprávu pro autora se nepodařilo odeslat:', status, error);
      })
      .always(function () {
        submit.removeClass('is-loading').removeAttr('aria-busy');
        resetRecaptcha();
      });
  });
}

// Klávesnice v modálu „Zpráva pro autora“: Tab zůstane v dialogu, Escape ho zavře
// a fokus se vrátí na odkaz, který ho otevřel. Otevírání/zavírání řeší modal.js
// (ten trap ani Escape nemá) — tady jen doplněk pro tento dialog.
function initAutorMessageDialog(modal) {
  const trigger = document.querySelector('[data-modal="#autorMessageModal"]');
  const closeButton = modal.querySelector('.js-modal-close');
  let opener = null;

  if (!trigger || !closeButton) {
    return;
  }

  trigger.addEventListener('click', () => {
    opener = trigger;
  });

  closeButton.addEventListener('click', () => {
    // modal.js zavírá v listeneru na body — fokus vrátit až po něm
    setTimeout(() => {
      if (opener) {
        opener.focus();
        opener = null;
      }
    }, 0);
  });

  const focusable = () => Array.from(modal.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), textarea:not([disabled])'
  )).filter((el) => el.offsetParent !== null);

  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('active')) {
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      closeButton.click();
      return;
    }

    if (e.key !== 'Tab') {
      return;
    }

    const items = focusable();
    if (!items.length) {
      return;
    }

    const first = items[0];
    const last = items[items.length - 1];
    const inside = modal.contains(document.activeElement);

    if (e.shiftKey && (!inside || document.activeElement === first)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (!inside || document.activeElement === last)) {
      e.preventDefault();
      first.focus();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-autor-bio').forEach(initAutorBio);

  const messageModal = document.getElementById('autorMessageModal');
  if (messageModal) {
    initAutorMessageDialog(messageModal);
  }

  const more = document.querySelector('.js-autor-articles-more');
  if (more) {
    initAutorArticles(more);
  }

  if (typeof window.jQuery !== 'undefined') {
    const form = window.jQuery('#autorMessageForm');
    if (form.length) {
      initAutorMessageForm(window.jQuery, form);
    }
  }
});
